import React, { useEffect, useState, useRef } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import Button from '../ui/Button';
// Sample project data
const featuredProjects = [{
  id: '1',
  title: 'Duplex (Oguweuyi Site, Edo State)',
  description: 'A modern duplex featuring elegant design, premium finishes, and contemporary living spaces with custom interior elements and high-quality construction.',
  imageUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/doJtysMZ2cn8UzmYHd2dV1/WhatsApp_Image_2025-09-25_at_20.11.14_a91cca1b.jpg',
  category: 'Interior'
}, {
  id: '2',
  title: 'Duplex (Warri site, Delta State)',
  description: 'Luxury residential duplex with sophisticated architectural details, spacious interiors, and premium fixtures designed for comfort and elegance.',
  imageUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/pHY9Tt8e25nnUbvQbNh3Lp/WhatsApp_Image_2025-09-25_at_20.06.19_64d0896c.jpg',
  category: 'Construction'
}];
const FeaturedProjects = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex(current => (current + 1) % featuredProjects.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) {
        setIsVisible(true);
        observer.unobserve(entries[0].target);
      }
    }, {
      threshold: 0.1
    });
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);
  const goToProject = (index: number) => {
    setActiveIndex(index);
  };
  const nextProject = () => {
    setActiveIndex(current => (current + 1) % featuredProjects.length);
  };
  const prevProject = () => {
    setActiveIndex(current => (current - 1 + featuredProjects.length) % featuredProjects.length);
  };
  const activeProject = featuredProjects[activeIndex];
  return <section ref={sectionRef} className="py-20 bg-gray-50" data-id="element-111">
      <div className="container mx-auto px-4 md:px-6" data-id="element-112">
        <div className={`text-center mb-12 transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} data-id="element-113">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1a2e1a] mb-4" data-id="element-114">
            Featured Projects
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto" data-id="element-115">
            Explore some of our most innovative and impactful work across
            various sectors
          </p>
        </div>
        <div className={`relative overflow-hidden rounded-xl shadow-xl transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} data-id="element-116">
          <div className="aspect-w-16 aspect-h-9 md:aspect-h-7 lg:aspect-h-5 w-full" data-id="element-117">
            <img src={activeProject.imageUrl} alt={activeProject.title} className="w-full h-full object-cover transition-transform duration-700 ease-in-out" style={{
            transform: `scale(${activeIndex === 0 ? 1.05 : 1})`
          }} data-id="element-118" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent" data-id="element-119"></div>
          </div>
          <div className="absolute bottom-0 left-0 right-0 p-6 md:p-10" data-id="element-120">
            <span className="inline-block px-3 py-1 bg-[#95c11f] text-white text-sm font-medium rounded-full mb-3 animate-fadeIn" data-id="element-121">
              {activeProject.category}
            </span>
            <h3 className="text-2xl md:text-3xl font-bold text-white mb-2 animate-fadeIn" data-id="element-122">
              {activeProject.title}
            </h3>
            <p className="text-gray-200 mb-6 max-w-2xl animate-fadeIn" data-id="element-123">
              {activeProject.description}
            </p>
            <Button to={`/projects/${activeProject.id}`} variant="primary" className="animate-fadeIn" data-id="element-124">
              View Project
            </Button>
          </div>
          <div className="absolute top-1/2 left-4 transform -translate-y-1/2 flex flex-col space-y-2" data-id="element-125">
            <button onClick={prevProject} className="bg-white/20 hover:bg-white/30 text-white p-2 rounded-full backdrop-blur-sm transition-colors animate-fadeIn" aria-label="Previous project" data-id="element-126">
              <ChevronLeftIcon size={24} data-id="element-127" />
            </button>
          </div>
          <div className="absolute top-1/2 right-4 transform -translate-y-1/2 flex flex-col space-y-2" data-id="element-128">
            <button onClick={nextProject} className="bg-white/20 hover:bg-white/30 text-white p-2 rounded-full backdrop-blur-sm transition-colors animate-fadeIn" aria-label="Next project" data-id="element-129">
              <ChevronRightIcon size={24} data-id="element-130" />
            </button>
          </div>
          <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex space-x-2 animate-fadeIn" data-id="element-131">
            {featuredProjects.map((_, index) => <button key={index} onClick={() => goToProject(index)} className={`w-2.5 h-2.5 rounded-full transition-all ${index === activeIndex ? 'bg-white scale-125' : 'bg-white/50'}`} aria-label={`Go to project ${index + 1}`} data-id="element-132" />)}
          </div>
        </div>
      </div>
    </section>;
};
export default FeaturedProjects;